import { Link as RouterLink } from "react-router-dom";
import {
  Text,
  Badge,
  Button,
  Box,
  Link,
  Flex,
  Image,
  Spacer,
  SimpleGrid,
  HStack,
  VStack,
} from "@chakra-ui/react";
import MyImage from "./images/mrcai4.png";

import { useAuth } from "./AuthContext";
import LinkedInLogin from "./LinkedInLogin";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const { user, logout } = useAuth();

  const isUserActive = user?.platformUser?.isActive === "true";
  const isUserSuperAdmin = user?.platformUser?.isSuperAdmin === "true";
  const isUserAdmin = user?.platformUser?.isAdmin === "true";
  const isUserDeveloper = user?.platformUser?.isDeveloper === "true";
  const navigate = useNavigate();

  return (
    <Flex p={4} color="white" align="center">
      <Box display="flex" alignItems="center">
        <Link color="white" as={RouterLink} to="/" mr={4}>
          <Image
            src={MyImage}
            width="auto"
            height="auto"
            alt="Logo"
            objectFit="cover"
            top="0"
            left="0"
            mr={4}
          />
        </Link>
        <Link color="#666262" as={RouterLink} to="/Poc" mr={4}>
          <Text fontSize="xl" color="#666262" fontWeight="bold">
            PoC
          </Text>
        </Link>
        {isUserSuperAdmin && (
          <Link color="#666262" as={RouterLink} to="/Codex" mr={4}>
            <Text fontSize="xl" color="#666262" fontWeight="bold">
              Codex
            </Text>
          </Link>
        )}
        {isUserSuperAdmin && (
          <Link color="#666262" as={RouterLink} to="/Codify" mr={4}>
            <Text fontSize="xl" color="#666262" fontWeight="bold">
              Codify
            </Text>
          </Link>
        )}
        {isUserSuperAdmin && (
          <Link color="#666262" as={RouterLink} to="/Panner" mr={4}>
            <Text fontSize="xl" color="#666262" fontWeight="bold">
              Panner
            </Text>
          </Link>
        )}
      </Box>
      <Spacer />
      <Box>
        {user ? (
          <Flex align="center" ml="auto">
            <VStack>
              <HStack>
                <Badge
                  bg="#0077b5"
                  color="white"
                  mr={2}
                  fontSize="0.8em"
                  fontWeight="bold">
                  Environment : Proof Of Concept
                </Badge>
              </HStack>


              <HStack>
                {isUserDeveloper && (
                  <Badge
                    colorScheme="blue"
                    mr={2}
                    fontSize="0.8em"
                    fontWeight="bold">
                    Developer
                  </Badge>
                )}
                {isUserAdmin && (
                  <Badge
                    colorScheme="purple"
                    mr={2}
                    fontSize="0.8em"
                    fontWeight="bold">
                    Admin
                  </Badge>
                )}
                {isUserSuperAdmin && (
                  <Badge
                    colorScheme="orange"
                    mr={2}
                    fontSize="0.8em"
                    fontWeight="bold">
                    Super Admin
                  </Badge>
                )}
              </HStack>
            </VStack>

            <Image
              src={user.picture}
              alt="Profile"
              boxSize="48px"
              borderRadius="full"
              mr={2}
            />
            <Button
              colorScheme="red"
              size="sm"
              onClick={() => {
                logout();
                navigate("/");
              }}>
              Logout
            </Button>
          </Flex>
        ) : (
          <LinkedInLogin />
        )}
      </Box>
    </Flex>
  );
};

export default Navbar;
